// Motivo del último cobro fallido de un pedido, para la cola de cobro —
// SPEC_COBRO_FALLO_FACTURACION_v0.1.md RN-CF2 (en pos-graciela-api/docs).
// El API guarda `<situation>: <detalle técnico>`; acá se muestra en castellano.

const TEXTOS = {
  cobro_sin_contexto_fiscal: 'falta la configuración fiscal (timbrado, punto o serie). Avisá al administrador.',
  cobro_dato_invalido: 'un dato del pedido no es válido. Revisá el pedido.',
  cobro_stock_insuficiente: 'no había stock suficiente de un producto.',
  cobro_sin_mostrador: 'no hay depósito mostrador configurado.',
  cobro_autoabastecimiento_deshabilitado: 'faltaba stock en el mostrador y el autoabastecimiento está deshabilitado.',
  cobro_error_interno: 'error del sistema. Probá de nuevo; si se repite, avisá a soporte.'
}

export const textoMotivoCobro = (motivo) => {
  const texto = String(motivo || '').trim()
  if (!texto) return ''
  if (texto.startsWith('Recuperado:')) return texto
  const situacion = texto.split(':')[0]
  return `El último intento de cobro falló: ${TEXTOS[situacion] || texto}`
}
